var _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _path9, _path10, _path11, _path12, _path13, _path14, _defs;

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

function SvgBigLogo(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 203,
    height: 100,
    viewBox: "0 0 203 100",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M42.9102 46.3615C42.9102 45.1469 43.1226 43.9985 43.5474 42.9164C43.9722 41.8343 44.5759 40.8847 45.3584 40.0676C46.1633 39.2505 47.1247 38.61 48.2427 38.1463C49.3606 37.6604 50.6127 37.4175 51.9989 37.4175C53.81 37.4175 55.3639 37.815 56.6607 38.61C57.9798 39.383 58.9636 40.4209 59.612 41.7239L56.0235 42.8502C55.5986 42.1214 55.0285 41.5582 54.313 41.1607C53.5976 40.7411 52.8038 40.5313 51.9318 40.5313C51.194 40.5313 50.5009 40.6749 49.8525 40.962C49.2265 41.2491 48.6787 41.6576 48.2091 42.1876C47.7396 42.6956 47.3707 43.3029 47.1024 44.0096C46.8341 44.7163 46.6999 45.5003 46.6999 46.3615C46.6999 47.2007 46.8341 47.9847 47.1024 48.7135C47.3931 49.4202 47.7731 50.0385 48.2427 50.5686C48.7346 51.0986 49.2935 51.5182 49.9196 51.8273C50.568 52.1144 51.2499 52.258 51.9654 52.258C52.4126 52.258 52.8597 52.2028 53.3069 52.0924C53.7541 51.9598 54.1565 51.7832 54.5143 51.5623C54.8944 51.3415 55.2186 51.0875 55.4869 50.8004C55.7775 50.5133 55.9899 50.2042 56.1241 49.8729L59.7462 50.9329C59.1648 52.2359 58.1922 53.307 56.8284 54.1462C55.4645 54.9633 53.8547 55.3718 51.9989 55.3718C50.635 55.3718 49.3941 55.1289 48.2762 54.6431C47.1583 54.1572 46.1969 53.5057 45.392 52.6886C44.6094 51.8494 43.9945 50.8888 43.5474 49.8067C43.1226 48.7245 42.9102 47.5762 42.9102 46.3615Z",
    fill: "#5C595B"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M70.5021 55.3718C69.1159 55.3718 67.8638 55.1289 66.7459 54.6431C65.6503 54.1572 64.7113 53.5057 63.9287 52.6886C63.1462 51.8715 62.5425 50.9219 62.1177 49.8398C61.6928 48.7356 61.4804 47.5872 61.4804 46.3947C61.4804 45.2021 61.6928 44.0648 62.1177 42.9827C62.5425 41.8785 63.1462 40.9178 63.9287 40.1007C64.7336 39.2836 65.6839 38.6321 66.7794 38.1463C67.8974 37.6604 69.1383 37.4175 70.5021 37.4175C71.866 37.4175 73.0957 37.6604 74.1913 38.1463C75.3092 38.6321 76.2595 39.2836 77.042 40.1007C77.8469 40.9178 78.4618 41.8785 78.8866 42.9827C79.3114 44.0648 79.5238 45.2021 79.5238 46.3947C79.5238 47.5872 79.3114 48.7356 78.8866 49.8398C78.4618 50.9219 77.8469 51.8715 77.042 52.6886C76.2595 53.5057 75.3092 54.1572 74.1913 54.6431C73.0957 55.1289 71.866 55.3718 70.5021 55.3718ZM65.2702 46.4278C65.2702 47.267 65.4044 48.0399 65.6727 48.7466C65.941 49.4533 66.3099 50.0717 66.7794 50.6017C67.249 51.1096 67.7967 51.5182 68.4228 51.8273C69.0712 52.1144 69.7643 52.258 70.5021 52.258C71.24 52.258 71.9219 52.1144 72.5479 51.8273C73.1963 51.5182 73.7553 51.0986 74.2248 50.5686C74.6944 50.0385 75.0633 49.4202 75.3316 48.7135C75.5999 48.0068 75.734 47.2339 75.734 46.3947C75.734 45.5775 75.5999 44.8156 75.3316 44.109C75.0633 43.3802 74.6944 42.7508 74.2248 42.2208C73.7553 41.6907 73.1963 41.2822 72.5479 40.9951C71.9219 40.6859 71.24 40.5313 70.5021 40.5313C69.7867 40.5313 69.1047 40.6859 68.4563 40.9951C67.8303 41.3043 67.2825 41.7239 66.813 42.2539C66.3434 42.7839 65.9633 43.4133 65.6727 44.1421C65.4044 44.8488 65.2702 45.6107 65.2702 46.4278Z",
    fill: "#5C595B"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M109.626 55.0406H105.937V45.3346C105.937 43.7225 105.669 42.541 105.132 41.7901C104.595 41.0393 103.813 40.6638 102.784 40.6638C101.734 40.6638 100.772 41.0503 99.9002 41.8233C99.0505 42.5741 98.4357 43.5569 98.0556 44.7715V55.0406H94.3664V45.3346C94.3664 43.7004 94.0981 42.5189 93.5615 41.7901C93.0249 41.0393 92.2535 40.6638 91.2474 40.6638C90.1965 40.6638 89.2351 41.0393 88.3631 41.7901C87.4912 42.541 86.8651 43.5237 86.485 44.7384V55.0406H82.7959V37.7156H86.1496V41.1939C86.8428 39.9792 87.7483 39.0517 88.8662 38.4113C90.0065 37.7487 91.3033 37.4175 92.7566 37.4175C94.2099 37.4175 95.3502 37.7929 96.1775 38.5438C97.0271 39.2946 97.5525 40.2332 97.7537 41.3595C98.4916 40.0786 99.4195 39.1069 100.537 38.4444C101.655 37.7598 102.93 37.4175 104.361 37.4175C105.389 37.4175 106.239 37.6162 106.91 38.0138C107.603 38.3892 108.15 38.8971 108.553 39.5376C108.955 40.178 109.235 40.9288 109.391 41.7901C109.548 42.6293 109.626 43.5237 109.626 44.4733V55.0406Z",
    fill: "#5C595B"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M123.838 55.3718C122.429 55.3718 121.189 55.0406 120.115 54.3781C119.042 53.7155 118.193 52.8543 117.566 51.7942V62.0964H113.877V37.7156H117.131V40.8295C117.801 39.7915 118.662 38.9634 119.713 38.345C120.786 37.7267 121.993 37.4175 123.335 37.4175C124.542 37.4175 125.649 37.6604 126.655 38.1463C127.661 38.6321 128.533 39.2836 129.271 40.1007C130.009 40.9178 130.579 41.8674 130.982 42.9495C131.406 44.0317 131.619 45.169 131.619 46.3615C131.619 47.6203 131.429 48.8018 131.049 49.906C130.669 50.9881 130.132 51.9378 129.439 52.7549C128.746 53.5499 127.919 54.1903 126.957 54.6762C126.018 55.14 124.978 55.3718 123.838 55.3718ZM122.631 52.258C123.413 52.258 124.118 52.0924 124.744 51.7611C125.392 51.4298 125.94 50.9881 126.387 50.436C126.856 49.8839 127.214 49.2545 127.46 48.5479C127.706 47.8412 127.829 47.1124 127.829 46.3615C127.829 45.5665 127.684 44.8156 127.393 44.109C127.125 43.4023 126.745 42.7839 126.253 42.2539C125.783 41.7239 125.213 41.3043 124.542 40.9951C123.872 40.6859 123.145 40.5313 122.362 40.5313C121.893 40.5313 121.401 40.6197 120.887 40.7963C120.373 40.973 119.892 41.2159 119.445 41.5251C118.997 41.8343 118.606 42.1987 118.271 42.6183C117.935 43.0158 117.701 43.4575 117.566 43.9433V48.4816C117.79 49.0116 118.081 49.5085 118.438 49.9723C118.796 50.436 119.187 50.8336 119.612 51.1648C120.059 51.4961 120.54 51.7611 121.054 51.9598C121.569 52.1586 122.094 52.258 122.631 52.258Z",
    fill: "#2898FF"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M144.797 40.8626C143.366 40.9068 142.091 41.238 140.974 41.8564C139.878 42.4527 139.095 43.3139 138.626 44.4402V55.0406H134.937V37.7156H138.358V41.5914C138.961 40.3988 139.744 39.4492 140.705 38.7425C141.689 38.0138 142.74 37.6162 143.858 37.55C144.081 37.55 144.26 37.55 144.394 37.55C144.551 37.55 144.685 37.561 144.797 37.5831V40.8626Z",
    fill: "#2898FF"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M154.478 55.3718C153.092 55.3718 151.839 55.1289 150.722 54.6431C149.626 54.1572 148.687 53.5057 147.904 52.6886C147.122 51.8715 146.518 50.9219 146.093 49.8398C145.669 48.7356 145.456 47.5872 145.456 46.3947C145.456 45.2021 145.669 44.0648 146.093 42.9827C146.518 41.8785 147.122 40.9178 147.904 40.1007C148.709 39.2836 149.66 38.6321 150.755 38.1463C151.873 37.6604 153.114 37.4175 154.478 37.4175C155.842 37.4175 157.071 37.6604 158.167 38.1463C159.285 38.6321 160.235 39.2836 161.018 40.1007C161.823 40.9178 162.437 41.8785 162.862 42.9827C163.287 44.0648 163.499 45.2021 163.499 46.3947C163.499 47.5872 163.287 48.7356 162.862 49.8398C162.437 50.9219 161.823 51.8715 161.018 52.6886C160.235 53.5057 159.285 54.1572 158.167 54.6431C157.071 55.1289 155.842 55.3718 154.478 55.3718ZM149.246 46.4278C149.246 47.267 149.38 48.0399 149.648 48.7466C149.917 49.4533 150.286 50.0717 150.755 50.6017C151.225 51.1096 151.772 51.5182 152.398 51.8273C153.047 52.1144 153.74 52.258 154.478 52.258C155.216 52.258 155.898 52.1144 156.524 51.8273C157.172 51.5182 157.731 51.0986 158.201 50.5686C158.67 50.0385 159.039 49.4202 159.307 48.7135C159.576 48.0068 159.71 47.2339 159.71 46.3947C159.71 45.5775 159.576 44.8156 159.307 44.109C159.039 43.3802 158.67 42.7508 158.201 42.2208C157.731 41.6907 157.172 41.2822 156.524 40.9951C155.898 40.6859 155.216 40.5313 154.478 40.5313C153.762 40.5313 153.08 40.6859 152.432 40.9951C151.806 41.3043 151.258 41.7239 150.789 42.2539C150.319 42.7839 149.939 43.4133 149.648 44.1421C149.38 44.8488 149.246 45.6107 149.246 46.4278Z",
    fill: "#2898FF"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M176.732 55.3718C175.324 55.3718 174.083 55.0406 173.01 54.3781C171.936 53.7155 171.087 52.8543 170.461 51.7942V62.0964H166.772V37.7156H170.025V40.8295C170.695 39.7915 171.556 38.9634 172.607 38.345C173.68 37.7267 174.888 37.4175 176.229 37.4175C177.437 37.4175 178.543 37.6604 179.549 38.1463C180.556 38.6321 181.428 39.2836 182.165 40.1007C182.903 40.9178 183.473 41.8674 183.876 42.9495C184.301 44.0317 184.513 45.169 184.513 46.3615C184.513 47.6203 184.323 48.8018 183.943 49.906C183.563 50.9881 183.026 51.9378 182.333 52.7549C181.64 53.5499 180.813 54.1903 179.851 54.6762C178.912 55.14 177.873 55.3718 176.732 55.3718ZM175.525 52.258C176.307 52.258 177.012 52.0924 177.638 51.7611C178.286 51.4298 178.834 50.9881 179.281 50.436C179.751 49.8839 180.108 49.2545 180.354 48.5479C180.6 47.8412 180.723 47.1124 180.723 46.3615C180.723 45.5665 180.578 44.8156 180.287 44.109C180.019 43.4023 179.639 42.7839 179.147 42.2539C178.677 41.7239 178.107 41.3043 177.437 40.9951C176.766 40.6859 176.039 40.5313 175.257 40.5313C174.787 40.5313 174.295 40.6197 173.781 40.7963C173.267 40.973 172.786 41.2159 172.339 41.5251C171.892 41.8343 171.5 42.1987 171.165 42.6183C170.83 43.0158 170.595 43.4575 170.461 43.9433V48.4816C170.684 49.0116 170.975 49.5085 171.333 49.9723C171.69 50.436 172.082 50.8336 172.507 51.1648C172.954 51.4961 173.434 51.7611 173.949 51.9598C174.463 52.1586 174.988 52.258 175.525 52.258Z",
    fill: "#2898FF"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M194.203 55.3718C192.795 55.3718 191.386 55.151 189.977 54.7093C188.591 54.2456 187.395 53.5941 186.389 52.7549L187.865 50.436C188.915 51.1869 189.955 51.7611 190.984 52.1586C192.012 52.534 193.063 52.7218 194.136 52.7218C195.232 52.7218 196.092 52.5119 196.718 52.0924C197.367 51.6728 197.691 51.0765 197.691 50.3035C197.691 49.5748 197.333 49.0447 196.618 48.7135C195.902 48.3822 194.784 48.0178 193.264 47.6203C192.169 47.3332 191.229 47.0572 190.447 46.7922C189.664 46.5272 189.027 46.218 188.535 45.8646C188.043 45.5113 187.686 45.1027 187.462 44.639C187.238 44.1752 187.127 43.6121 187.127 42.9495C187.127 42.0662 187.294 41.2822 187.63 40.5976C187.987 39.913 188.468 39.3388 189.072 38.875C189.698 38.3892 190.425 38.0248 191.252 37.7819C192.079 37.5389 192.973 37.4175 193.935 37.4175C195.254 37.4175 196.484 37.6162 197.624 38.0138C198.764 38.4113 199.782 38.9855 200.676 39.7363L199.1 41.9226C197.468 40.6418 195.735 40.0013 193.901 40.0013C192.962 40.0013 192.169 40.2001 191.52 40.5976C190.894 40.973 190.581 41.5803 190.581 42.4195C190.581 42.7729 190.648 43.071 190.782 43.3139C190.916 43.5569 191.129 43.7667 191.42 43.9433C191.733 44.12 192.124 44.2856 192.593 44.4402C193.085 44.5727 193.689 44.7273 194.404 44.904C195.589 45.1911 196.607 45.4782 197.456 45.7653C198.328 46.0524 199.044 46.3947 199.603 46.7922C200.162 47.1676 200.575 47.6203 200.844 48.1503C201.112 48.6583 201.246 49.2766 201.246 50.0054C201.246 51.6617 200.609 52.9757 199.334 53.9474C198.082 54.897 196.372 55.3718 194.203 55.3718Z",
    fill: "#2898FF"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    d: "M21.3466 31.6646C21.3466 31.6646 7.16432 38.1274 7.16432 38.3503C7.16432 38.5731 7.0918 42.7039 7.0918 42.7039L15.4642 40.4913L21.3466 42.1229V31.6646Z",
    fill: "url(#paint0_linear_669_2157)"
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    d: "M15.7617 42.2742C15.8342 42.497 15.7617 48.5778 15.7617 48.5778L0.072523 52.1356L0 46.3095L15.7617 42.2742Z",
    fill: "url(#paint1_linear_669_2157)"
  })), _path11 || (_path11 = /*#__PURE__*/React.createElement("path", {
    d: "M24.8756 51.1487C24.9481 51.3636 24.8756 57.4603 24.8756 57.4603L6.97852 56.3142V51.5387L24.8756 51.1487Z",
    fill: "url(#paint2_linear_669_2157)"
  })), _path12 || (_path12 = /*#__PURE__*/React.createElement("path", {
    d: "M21.3457 31.6646L38.6142 42.5527L38.6384 46.6915L21.3457 42.115V31.6646Z",
    fill: "url(#paint3_linear_669_2157)"
  })), _path13 || (_path13 = /*#__PURE__*/React.createElement("path", {
    d: "M36.7038 48.164C36.7038 48.2834 36.8166 51.2283 36.8166 51.2283L15.793 48.5778V42.2742L36.7038 48.164Z",
    fill: "url(#paint4_linear_669_2157)"
  })), _path14 || (_path14 = /*#__PURE__*/React.createElement("path", {
    d: "M24.875 51.1487L40.9912 53.3932C40.9912 53.3932 41.2249 57.4205 41.1121 57.3728C40.9993 57.325 24.9153 57.4444 24.9153 57.4444L24.875 51.1487Z",
    fill: "url(#paint5_linear_669_2157)"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_669_2157",
    x1: 5.3593,
    y1: 37.1803,
    x2: 20.8551,
    y2: 37.1803,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#231F20"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.1,
    stopColor: "#403D3E"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.28,
    stopColor: "#727071"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.45,
    stopColor: "#9A9899"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.6,
    stopColor: "#B6B5B5"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.74,
    stopColor: "#C7C7C7"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.84,
    stopColor: "#CDCDCD"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint1_linear_669_2157",
    x1: 0,
    y1: 47.2009,
    x2: 15.81,
    y2: 47.2009,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#231F20"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.12,
    stopColor: "#403D3E"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.33,
    stopColor: "#727071"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.54,
    stopColor: "#9A9899"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.72,
    stopColor: "#B6B5B5"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.88,
    stopColor: "#C7C7C7"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#CDCDCD"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint2_linear_669_2157",
    x1: 6.94628,
    y1: 54.3005,
    x2: 24.9078,
    y2: 54.3005,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#231F20"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.01,
    stopColor: "#282425"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.13,
    stopColor: "#535151"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.26,
    stopColor: "#797777"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.39,
    stopColor: "#979696"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.52,
    stopColor: "#AFAEAF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.66,
    stopColor: "#C0C0C0"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.81,
    stopColor: "#CACACA"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#CDCDCD"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint3_linear_669_2157",
    x1: 23.8195,
    y1: 38.0478,
    x2: 37.32,
    y2: 44.4881,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#231F20"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.12,
    stopColor: "#403D3E"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.33,
    stopColor: "#727071"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.54,
    stopColor: "#9A9899"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.72,
    stopColor: "#B6B5B5"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.88,
    stopColor: "#C7C7C7"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#CDCDCD"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint4_linear_669_2157",
    x1: 16.1556,
    y1: 46.7472,
    x2: 39.2501,
    y2: 46.7472,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#231F20"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.07,
    stopColor: "#393536"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.23,
    stopColor: "#666364"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.39,
    stopColor: "#8B898A"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.55,
    stopColor: "#A8A7A7"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.7,
    stopColor: "#BCBCBC"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.86,
    stopColor: "#C9C9C9"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#CDCDCD"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint5_linear_669_2157",
    x1: 23.9967,
    y1: 54.0458,
    x2: 39.8536,
    y2: 56.5652,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.11,
    stopColor: "#231F20"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.22,
    stopColor: "#403D3E"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.41,
    stopColor: "#727071"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.59,
    stopColor: "#9A9899"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.75,
    stopColor: "#B6B5B5"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.9,
    stopColor: "#C7C7C7"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#CDCDCD"
  })))));
}

const ForwardRef = /*#__PURE__*/React.forwardRef(SvgBigLogo);
export default __webpack_public_path__ + "static/media/bigLogo.defc9bc89cc6e5f61ac9a1cbe6132402.svg";
export { ForwardRef as ReactComponent };